import React, { useEffect, useState } from "react";
import { Stack, Typography } from "@mui/material";
import BarChart from "../../../components/BarChart";
import { sumData } from "../../../utils";
import { useSelector } from "react-redux";
import { postRequest } from "../../../services/api";

const DateWiseDeadCount = () => {
  const { startDate, endDate } = useSelector((state) => state.dashboard);
  const { user, userSetting } = useSelector((state) => state.user);
  const [data, setData] = useState([]);
  const [chartData, setChartData] = useState([]);

  const dateWiseFormat = (data) => {
    const arrayResultByDay = sumData(data, "forWeek", 'dataAsOfDt', 'cnt');
    setChartData(arrayResultByDay);
  };

  useEffect(() => {
      dateWiseFormat(data);
  }, [data]);

  const fetchDateWiseShipmentData = async () => {
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user.token}`,
    };
    let payload = {
      custCode: userSetting[0].currCustomer,
      whseCode: userSetting[0].currWarehouse,
      fromDate: startDate.format("YYYY-MM-DD"),
      toDate: endDate.format("YYYY-MM-DD"),
      "daysToDeclareDead":"60"
    };
    const response = await postRequest(
      "user/getDashCounts_deadStocks",
      payload,
      headers
    );
    setData(response.data.Payload);
  };

  useEffect(() => {
    fetchDateWiseShipmentData();
  }, [startDate, endDate, userSetting]);

  return (
    <div>
      <Stack
        direction="row"
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <Typography>Inactive Stock</Typography>
      </Stack>

      <BarChart chartName={"Date Wise Dead Stock Count"} chartData={chartData} name={"Count"} yAxisLabel="Count" xAxisLabel="Week"/>
    </div>
  );
};

export default DateWiseDeadCount;
